import { render, staticRenderFns } from "./WxAccountForm.vue?vue&type=template&id=df052d94&"
import script from "./WxAccountForm.vue?vue&type=script&lang=js&"
export * from "./WxAccountForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports